<div *ngIf="footnotes">
    <div *ngFor="let section of sections">
        <p class="footnote-section rps-paragraph-one rps-grey rps-mark-bold">{{sectionsMap[section]}}</p>
        <div style="display: inline-flex;" *ngFor="let footnote of footnotes">
            <div class="footnote-text" *ngIf="footnote.section === section" [innerHTML]="footnote.id  | sanitizeHtml"></div>
            <div class="footnote-text-content" *ngIf="footnote.section === section" [innerHTML]="footnote.text | sanitizeHtml"></div>
            <div class="d-none" [attr.aria-hidden]="true" [attr.data-rpa-tag-id]="'content' + '_' + footnote.section + '_' + footnote.name" *ngIf="footnote.section === section" [innerHTML]="footnote.text | sanitizeHtml"></div>
          </div>
    </div>
</div>
